'use strict';

var _ = require('lodash');
var ClearDemandAdjustmentModalController = function ClearDemandAdjustmentModalController($scope) {
  $scope.clearDemandAdjustments = false;
  $scope.disableSubmit = false;
  $scope.publishDemandCalendars = function () {
    var selectedEntries = _.filter($scope.selectedCalendars, function (calendar) {
      return calendar.includeForPublish;
    });
    $scope.$emit('pooled-seasonality:submit-publish-request', $scope.clearDemandAdjustments, selectedEntries);
    $scope.clearDemandAdjustments = false;
  };
  $scope.checkButtonStatus = function () {
    $scope.disableSubmit = _.isUndefined(_.find($scope.selectedCalendars, {
      includeForPublish: true
    }));
  };
  $scope.resetModal = function () {
    $scope.clearDemandAdjustments = false;
    $scope.disableSubmit = false;
  };
};
ClearDemandAdjustmentModalController.$inject = ['$scope'];
module.exports = ClearDemandAdjustmentModalController;